/**
 * Returns the object with the properties values as milliseconds.
 * @param {object} data
 * @return {object}
 */
export default function parsePropertiesToMilliseconds(data = {}) {
  if (Object.keys(data).length > 0) {
    const { introEndSeconds, outroStartSeconds } = data;
    if (
      parseInt(introEndSeconds / 1000) === 0 ||
      (parseInt(outroStartSeconds / 1000) > 0 && outroStartSeconds.toString().length < 5)
    ) {
      Object.keys(data).forEach(key => (data[key] = data[key] * 1000));
    }
    return data;
  }
  return null;
}
